import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useLiffProfile } from "../../context/LiffProfileContext";
import { useTranslation } from "react-i18next";
import ErrorModal from "../modals/ErrorModal";
import OtpForm from "../otp/OtpForm";
import LoadingBar from "../LoadingBar";

const PdpaConsent = ({ show, onAccept, onClose, payload }) => {
  const [pdpaContent, setPdpaContent] = useState("");
  const { authToken, userId } = useLiffProfile();
  const [showOtp, setShowOtp] = useState(false);
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [canConsent, setCanConsent] = useState(false);
  const [otpPayload, setOtpPayload] = useState(null);
  const contentRef = useRef(null);


  useEffect(() => {
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/pdpa/template`;
    const clientAuth = process.env.REACT_APP_CLIENT_AUTH;

    const fetchPdpa = async () => {
      try {
        const res = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "X-Client-Auth": clientAuth,
            "x-user-id": userId,
            "Accept-Language": i18n.language.toUpperCase(),
          },
        });
        const data = res?.data?.data;
        if (data?.consentMessage) {
          setPdpaContent(data.consentMessage);
        } else {
          setError(t("pdpa.not_found"));
        }
      } catch (err) {
        console.error("Error fetching PDPA:", err);
        setError(t("pdpa.fetch_error"));
      }
    };

    fetchPdpa();
  }, [authToken, userId, t]);

  const handleConsentAccept = () => {
    setOtpPayload({
      ...payload,
      consentStatus: "C", // ยินยอม
    });
    setShowOtp(true);
  };

  const handleConsentReject = () => {
    setOtpPayload({
      ...payload,
      consentStatus: "N", // ไม่ยินยอม
    });
    setShowOtp(true);
  };

  const handleScroll = () => {
    if (contentRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        setCanConsent(true);
      }
    }
  };

  if (error) {
    return <ErrorModal error={error} onClose={onClose} />;
  }

  if (showOtp && otpPayload) {
    return (
      <OtpForm
        mobilePhone={otpPayload.mobile}
        idCard={otpPayload.id}
        consentStatus={otpPayload.consentStatus}
        onSubmit={onAccept}
        onClose={() => setShowOtp(false)}
      />
    );
  }

  if (!pdpaContent) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg max-w-md w-full p-6 shadow-lg relative">
          <button
            className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 text-xl"
            onClick={onClose}
          >
            &times;
          </button>
          <h3 className="text-xl font-semibold mb-4">{t("pdpa_header")}</h3>
          <div
            className="overflow-y-auto max-h-[50vh] mb-4"
            ref={contentRef}
            onScroll={handleScroll}
          >
            <p className="text-base whitespace-pre-wrap text-left">
              {pdpaContent}
            </p>
          </div>
          <div className="flex justify-center gap-4">
            <button
              className="px-6 py-2 rounded-full bg-gray-300 text-black"
              onClick={handleConsentReject}
            >
              {t("not_consent")}
            </button>
            <button
              className={`px-6 py-2 rounded-full ${
                canConsent ? "bg-primary" : "bg-gray-400 cursor-not-allowed"
              } text-white`}
              onClick={handleConsentAccept}
              disabled={!canConsent}
            >
              {t("consent")}
            </button>
          </div>
        </div>
        {loading && <LoadingBar />}
      </div>
    </>
  );
};

export default PdpaConsent;

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useLiffProfile } from "../../context/LiffProfileContext";
// import { useTranslation } from "react-i18next";
// import ErrorModal from "../modals/ErrorModal";
// import OtpForm from "../otp/OtpForm";

// const PdpaConsent = ({ show, onAccept, onClose, payload }) => {
//   const [pdpaContent, setPdpaContent] = useState("");
//   const { authToken, userId } = useLiffProfile();
//   const [showOtp, setShowOtp] = useState(false);
//   const { t, i18n } = useTranslation();
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const apiUrl = `${process.env.REACT_APP_API_URL}/api/pdpa/template`;
//     const clientAuth = process.env.REACT_APP_CLIENT_AUTH;

//     const fetchPdpa = async () => {
//       try {
//         const res = await axios.get(apiUrl, {
//           headers: {
//             Authorization: `Bearer ${authToken}`,
//             "X-Client-Auth": clientAuth,
//             "x-user-id": userId,
//             "Accept-Language": i18n.language.toUpperCase(),
//           },
//         });
//         const data = res?.data?.data;
//         if (data?.consentMessage) {
//           setPdpaContent(data.consentMessage);
//           console.log(data?.consentMessage)
//         } else {
//           setError(t("pdpa.not_found"));
//         }
//       } catch (err) {
//         console.error("Error fetching PDPA:", err);
//         setError(t("pdpa.fetch_error"));
//       }
//     };

//     fetchPdpa();
//   }, [authToken, userId, t]);

//   const handleConsentAccept = async () => {
//     setShowOtp(true);
//   };

//   if (error) {
//     return <ErrorModal error={error} onClose={onClose} />;
//   }

//   if (showOtp) {
//     return (
//       <OtpForm
//         mobile={payload.mobile}
//         idCard={payload.id}
//         onSubmit={onAccept}
//         onClose={() => setShowOtp(false)}
//       />
//     );
//   }

//   if (!pdpaContent) return null;

//   return (
//     <>
//       <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//         <div className="bg-white rounded-lg max-w-md w-full p-6 shadow-lg relative">
//           <button
//             className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 text-xl"
//             onClick={onClose}
//           >
//             &times;
//           </button>
//           <h3 className="text-xl font-semibold mb-4">{t("pdpa_header")}</h3>
//           <div className="overflow-y-auto max-h-[50vh] mb-4">
//             <p className="text-base whitespace-pre-wrap text-left">
//               {pdpaContent}
//             </p>
//           </div>
//           <div className="flex justify-center gap-4">
//             <button
//               className="px-6 py-2 rounded-full bg-gray-300 text-black"
//               onClick={onClose}
//             >
//               {t("not_consent")}
//             </button>
//             <button
//               className="px-6 py-2 rounded-full bg-primary text-white"
//               onClick={handleConsentAccept}
//             >
//               {t("consent")}
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default PdpaConsent;
